<script>
  import Layout from '@/views/layouts/main'
  import PageHeader from '@/components/page-header'
  import SchedulingRequestController from '@/controller/SchedulingRequestController'
  import { http } from '@/helpers/easyindustriaapi/config'
  import moment from 'moment'
  import Swal from 'sweetalert2'
  
  export default {
    components: { Layout, PageHeader },
    data() {
      return {
        titleBody: 'Solicitações de Reagendamento',
        items: [
          { text: 'Agendamentos', href: '/agendamentos' },
          { text: 'Solicitações de Reagendamento', active: true }
        ],
        currentUser: null,
        currentEmpresa: null,
        schedulingRequests: [],
        professionals: [],
        loading: false,
        filtering: false,
        params: {
          professional_id: null,
          data_inicio: null,
          data_fim: null,
          status: null,
          atendimento_id: null
        },
        statusOptions: [
          { value: null, text: 'Todos' },
          { value: 'pending', text: 'Pendente' },
          { value: 'approved', text: 'Aprovado' },
          { value: 'rejected', text: 'Rejeitado' },
          { value: 'processed', text: 'Processado' }
        ],
        selectedRequest: null,
        showRejectModal: false,
        rejectForm: {
          id: null,
          rejection_reason: ''
        },
        // Paginação
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        sortBy: 'id',
        sortDesc: true,
        filter: null,
        filterOn: [],
        fields: [
          {
            label: 'ID',
            key: 'id',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Atendimento ID',
            key: 'atendimento_id',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Profissional',
            key: 'professional_name',
            sortable: true,
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          {
            label: 'Paciente',
            key: 'pacient_name',
            sortable: true,
            tdClass: 'text-left',
            thClass: 'text-center'
          },
          {
            label: 'Data Término Atual',
            key: 'old_date_end',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Nova Data',
            key: 'new_date_start',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Novo Horário',
            key: 'new_time',
            sortable: false,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Status',
            key: 'status',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Solicitado em',
            key: 'created_at',
            sortable: true,
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Ações',
            key: 'acoes',
            sortable: false,
            tdClass: 'text-center',
            thClass: 'text-center'
          }
        ]
      }
    },
    created() {
      this.currentUser = JSON.parse(localStorage.getItem('user'))
      this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
      this.controller = new SchedulingRequestController(this.currentUser, this.currentEmpresa)
      
      // Carregar parâmetros salvos do localStorage
      if (localStorage.getItem('scheduling_requests_params')) {
        this.params = JSON.parse(localStorage.getItem('scheduling_requests_params'))
      }
    },
    mounted() {
      this.loadProfessionals()
      this.load()
      // Aplicar filtros salvos se existirem
      if (this.params && Object.keys(this.params).some(key => this.params[key] !== null)) {
        this.onFilters(this.params)
      }
    },
    computed: {
      rows() {
        return this.filteredRequests.length
      },
      clonefoot() {
        return this.schedulingRequests.length > 10 ? true : false
      },
      filteredRequests() {
        // Filtro client-side para demonstração
        // Quando o backend estiver pronto, os filtros serão aplicados na API
        let filtered = [...this.schedulingRequests]
        
        if (this.params.professional_id) {
          filtered = filtered.filter(req => req.professional_id == this.params.professional_id)
        }
        
        if (this.params.status) {
          filtered = filtered.filter(req => req.status === this.params.status)
        }
        
        if (this.params.atendimento_id) {
          filtered = filtered.filter(req => req.atendimento_id == this.params.atendimento_id)
        }
        
        if (this.params.data_inicio) {
          filtered = filtered.filter(req => {
            const reqDate = moment(req.created_at).format('YYYY-MM-DD')
            return reqDate >= this.params.data_inicio
          })
        }
        
        if (this.params.data_fim) {
          filtered = filtered.filter(req => {
            const reqDate = moment(req.created_at).format('YYYY-MM-DD')
            return reqDate <= this.params.data_fim
          })
        }
        
        return filtered
      }
    },
    methods: {
      async loadProfessionals() {
        try {
          const response = await http.get(`/professional?empresa_id=${this.currentEmpresa.id}`)
          this.professionals = response.data || []
        } catch (error) {
          console.error('Erro ao carregar profissionais:', error)
          this.professionals = []
        }
      },
      async load(params = null) {
        try {
          this.loading = true
          
          const data = await this.controller.getSchedulingRequests(params)
          
          // Processar dados da API
          this.schedulingRequests = (data.data || data || []).map(req => ({
            ...req,
            professional_name: req.professional?.name || 'N/A',
            pacient_name: req.atendimento?.pacient?.nome || 'N/A'
          }))
        } catch (error) {
          console.error('Erro ao carregar solicitações:', error)
          const errorMessage = error.message || 'Erro ao carregar solicitações de reagendamento'
          this.showError(errorMessage)
        } finally {
          this.loading = false
        }
      },
      async onFilters(params) {
        try {
          this.filtering = true
          this.loading = true
          
          // Salvar parâmetros no localStorage
          localStorage.setItem('scheduling_requests_params', JSON.stringify(params))
          
          // Carregar dados com filtros
          const data = await this.controller.getSchedulingRequests(params)
          
          // Processar dados da API
          this.schedulingRequests = (data.data || data || []).map(req => ({
            ...req,
            professional_name: req.professional?.name || 'N/A',
            pacient_name: req.atendimento?.pacient?.nome || 'N/A'
          }))
          
          this.showSuccess('Filtros aplicados com sucesso!')
        } catch (error) {
          console.error('Erro ao aplicar filtros:', error)
          const errorMessage = error.message || error.response?.data?.message || 'Erro ao aplicar filtros'
          this.showError(errorMessage)
        } finally {
          this.filtering = false
          this.loading = false
        }
      },
      limparFiltros() {
        this.params = {
          professional_id: null,
          data_inicio: null,
          data_fim: null,
          status: null,
          atendimento_id: null
        }
        localStorage.removeItem('scheduling_requests_params')
        this.load()
      },
      formatDate(value) {
        if (!value) return '-'
        return moment(value).format('DD/MM/YYYY')
      },
      formatDateTime(value) {
        if (!value) return '-'
        return moment(value).format('DD/MM/YYYY HH:mm')
      },
      formatTime(value) {
        if (!value) return '-'
        return moment(value, 'HH:mm:ss').format('HH:mm')
      },
      formatStatus(status) {
        const statusMap = {
          'pending': 'Pendente',
          'approved': 'Aprovado',
          'rejected': 'Rejeitado',
          'processed': 'Processado'
        }
        return statusMap[status] || status
      },
      statusVariant(status) {
        const variantMap = {
          'pending': 'warning',
          'approved': 'info',
          'rejected': 'danger',
          'processed': 'success'
        }
        return variantMap[status] || 'secondary'
      },
      formatNewTime(row) {
        if (!row.new_time_start || !row.new_time_end) return '-'
        return `${this.formatTime(row.new_time_start)} - ${this.formatTime(row.new_time_end)}`
      },
      canApprove(row) {
        // row pode ser o objeto do slot (com row.item) ou o item diretamente
        const item = row.item || row
        const canApprove = item && item.status === 'pending'
        return canApprove
      },
      canReject(row) {
        // row pode ser o objeto do slot (com row.item) ou o item diretamente
        const item = row.item || row
        const canReject = item && item.status === 'pending'
        return canReject
      },
      async handleApprove(row) {
        const result = await Swal.fire({
          title: 'Confirmar Aprovação',
          text: 'Deseja aprovar esta solicitação de reagendamento? A agenda atual será encerrada e uma nova será criada.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, aprovar!',
          cancelButtonText: 'Cancelar'
        })
  
        if (!result.isConfirmed) {
          return
        }
  
        Swal.fire({
          title: 'Aguarde...',
          text: 'Processando aprovação...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          }
        })
  
        try {
          await this.controller.approveRequest(row.id)
          
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: 'Solicitação aprovada!',
            text: 'A solicitação foi aprovada e processada com sucesso. A agenda foi atualizada.',
            timer: 3000,
            timerProgressBar: true
          })
          
          // Recarregar lista
          await this.load()
        } catch (error) {
          console.error('Erro ao aprovar solicitação:', error)
          Swal.close()
          
          const errorMessage = error.message || 'Erro ao aprovar solicitação'
          
          Swal.fire({
            icon: 'error',
            title: 'Erro ao aprovar',
            html: errorMessage
          })
        }
      },
      openRejectModal(row) {
        this.rejectForm = {
          id: row.id,
          rejection_reason: ''
        }
        this.showRejectModal = true
        this.$nextTick(() => {
          this.$bvModal.show('modal-reject-request')
        })
      },
      closeRejectModal() {
        this.showRejectModal = false
        this.rejectForm = {
          id: null,
          rejection_reason: ''
        }
        this.$bvModal.hide('modal-reject-request')
      },
      async handleReject() {
        if (!this.rejectForm.rejection_reason || this.rejectForm.rejection_reason.trim() === '') {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção',
            text: 'Por favor, informe o motivo da rejeição.'
          })
          return
        }
  
        Swal.fire({
          title: 'Aguarde...',
          text: 'Processando rejeição...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          }
        })
  
        try {
          // TODO: Quando o backend estiver pronto, descomentar e usar:
          // const response = await http.put(`/scheduling-request/${this.rejectForm.id}/reject`, {
          //   id: this.rejectForm.id,
          //   rejection_reason: this.rejectForm.rejection_reason
          // })
          
          // Simulação de sucesso
          await new Promise(resolve => setTimeout(resolve, 1000))
          
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: 'Solicitação rejeitada!',
            text: 'A solicitação foi rejeitada com sucesso.',
            timer: 3000,
            timerProgressBar: true
          })
          
          this.closeRejectModal()
          await this.load()
        } catch (error) {
          console.error('Erro ao rejeitar solicitação:', error)
          Swal.close()
          
          let errorMessage = 'Erro ao rejeitar solicitação'
          if (error.response) {
            if (error.response.status === 422) {
              const errors = error.response.data.errors || {}
              const errorMessages = Object.values(errors).flat()
              errorMessage = errorMessages.join('<br>')
            } else if (error.response.data && error.response.data.error) {
              errorMessage = error.response.data.error
            }
          }
          
          Swal.fire({
            icon: 'error',
            title: 'Erro ao rejeitar',
            html: errorMessage
          })
        }
      },
      onFiltered() {
        this.currentPage = 1
      },
      showSuccess(message) {
        this.$bvToast.toast(message, {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      },
      showError(message) {
        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      },
      showWarning(message) {
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      }
    }
  }
  </script>
  
  <template>
    <Layout>
      <PageHeader :title="titleBody" :items="items" />
      <div class="row">
        <div class="col-md-12">
          <!-- Card de Cabeçalho com Botão de Filtros -->
          <div class="card mb-3">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-6">
                  <h5 class="mb-0">Solicitações de Reagendamento</h5>
                  <small class="text-muted">Gerencie as solicitações de reagendamento de agendas.</small>
                </div>
                <div class="col-sm-12 col-md-6 text-md-right mt-3 mt-md-0">
                  <!-- Botão de Filtros -->
                  <b-button
                    v-b-toggle="'collapse-filters'"
                    variant="primary"
                    class="mb-3 mr-2"
                  >
                    <i class="fas fa-filter"></i> Filtros
                  </b-button>
                  
                  <!-- Botão Atualizar -->
                  <b-button 
                    variant="outline-primary" 
                    class="ml-md-2 mt-2 mt-md-0 mb-3" 
                    @click="onFilters(params)" 
                    :disabled="filtering || loading"
                  >
                    <span v-if="loading || filtering">
                      <b-spinner small class="mr-2" /> Atualizando...
                    </span>
                    <span v-else>
                      <i class="bx bx-refresh"></i> Atualizar
                    </span>
                  </b-button>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Collapse de Filtros -->
          <b-collapse id="collapse-filters" class="mt-1">
            <b-card>
              <div class="row">
                <!-- Filtro por Profissional -->
                <div class="col-md-6 mb-3">
                  <b-form-group label="Profissional:">
                    <b-form-select
                      v-model="params.professional_id"
                      :options="[
                        { value: null, text: 'Todos' },
                        ...professionals.map(p => ({ value: p.id, text: p.name }))
                      ]"
                    />
                  </b-form-group>
                </div>
                
                <!-- Filtro por Status -->
                <div class="col-md-6 mb-3">
                  <b-form-group label="Status:">
                    <b-form-select
                      v-model="params.status"
                      :options="statusOptions"
                    />
                  </b-form-group>
                </div>
              </div>
  
              <div class="row">
                <!-- Filtro por Data Início -->
                <div class="col-md-6 mb-3">
                  <b-form-group label="Data Início:">
                    <input 
                      type="date" 
                      class="form-control" 
                      v-model="params.data_inicio"
                    />
                  </b-form-group>
                </div>
                
                <!-- Filtro por Data Fim -->
                <div class="col-md-6 mb-3">
                  <b-form-group label="Data Fim:">
                    <input 
                      type="date" 
                      class="form-control" 
                      v-model="params.data_fim"
                    />
                  </b-form-group>
                </div>
              </div>
  
              <div class="row">
                <!-- Filtro por Atendimento ID -->
                <div class="col-md-6 mb-3">
                  <b-form-group label="Atendimento ID:">
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model.number="params.atendimento_id"
                      placeholder="Digite o ID do atendimento"
                    />
                  </b-form-group>
                </div>
              </div>
  
              <!-- Botões de Ação -->
              <div class="row">
                <div class="col-12">
                  <b-button 
                    variant="primary" 
                    @click="onFilters(params)"
                    :disabled="filtering || loading"
                    class="mr-2"
                  >
                    <i class="fas fa-database"></i> Aplicar Filtros
                  </b-button>
                  <b-button 
                    variant="secondary" 
                    @click="limparFiltros"
                    :disabled="filtering || loading"
                  >
                    <i class="fas fa-eraser"></i> Limpar Filtros
                  </b-button>
                </div>
              </div>
            </b-card>
          </b-collapse>
  
          <!-- Tabela de Solicitações -->
          <div class="row mt-4">
            <div class="col-12">
              <b-card>
                <b-card-body>
                  <div class="table-responsive mb-0">
                    <b-table
                      :items="filteredRequests"
                      :fields="fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :hover="true"
                      :foot-clone="clonefoot"
                      :busy="loading"
                      table-class="table-sm"
                    >
                      <template #cell(old_date_end)="row">
                        {{ formatDate(row.item.old_date_end) }}
                      </template>
                      
                      <template #cell(new_date_start)="row">
                        {{ formatDate(row.item.new_date_start) }}
                      </template>
                      
                      <template #cell(new_time)="row">
                        {{ formatNewTime(row.item) }}
                      </template>
                      
                      <template #cell(status)="row">
                        <b-badge :variant="statusVariant(row.item.status)">
                          {{ formatStatus(row.item.status) }}
                        </b-badge>
                      </template>
                      
                      <template #cell(created_at)="row">
                        {{ formatDateTime(row.item.created_at) }}
                      </template>
                      
                      <template #cell(acoes)="row">
                        <b-dropdown 
                          :id="'dropdown-' + row.item.id" 
                          class="m-md-2"
                        >
                          <template #button-content>
                            <i class="bx ri-menu-line"></i>
                          </template>
                          <b-dropdown-item 
                            v-if="canApprove(row)"
                            @click="handleApprove(row.item)"
                          >
                            <i class="bx ri-check-line text-success"></i> Aprovar
                          </b-dropdown-item>
                          <b-dropdown-item 
                            v-if="canReject(row)"
                            @click="openRejectModal(row.item)"
                          >
                            <i class="bx ri-close-line text-danger"></i> Reprovar
                          </b-dropdown-item>
                          <b-dropdown-item 
                            v-if="!canApprove(row) && !canReject(row)"
                            disabled
                          >
                            <span class="text-muted">Nenhuma ação disponível</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </template>
                      
                      <template #table-busy>
                        <div class="text-center text-warning my-2">
                          <b-spinner class="align-middle mr-3"></b-spinner>
                          <strong>Carregando...</strong>
                        </div>
                        </template>
                      </b-table>
                    </div>
              </b-card-body>
            </b-card>
            </div>
          </div>
  
          <!-- Paginação -->
          <div class="row mt-4">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination 
                    v-model="currentPage" 
                    :total-rows="rows" 
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Modal de Rejeição -->
      <b-modal
        v-if="showRejectModal"
        id="modal-reject-request"
        title="Reprovar Solicitação"
        title-class="font-18"
        size="lg"
        hide-footer
        @hide="closeRejectModal"
        no-close-on-backdrop
      >
        <div class="form-group">
          <label for="rejection_reason">
            Motivo da Rejeição <span class="text-danger">*</span>
          </label>
          <textarea
            id="rejection_reason"
            class="form-control"
            v-model="rejectForm.rejection_reason"
            rows="4"
            placeholder="Informe o motivo da rejeição desta solicitação..."
            required
          ></textarea>
          <small class="form-text text-muted">
            Este motivo será registrado e poderá ser visualizado pelo profissional.
          </small>
        </div>
  
        <div class="form-row mt-3">
          <div class="col-md-12 text-right">
            <b-button 
              variant="secondary" 
              class="mr-2" 
              @click="closeRejectModal"
            >
              Cancelar
            </b-button>
            <b-button 
              variant="danger" 
              @click="handleReject"
              :disabled="!rejectForm.rejection_reason || rejectForm.rejection_reason.trim() === ''"
            >
              <i class="ri-close-line mr-1"></i>
              Reprovar Solicitação
            </b-button>
          </div>
        </div>
      </b-modal>
    </Layout>
  </template>
  
  <style scoped>
  .border-detail {
    border: 1px solid #e9ecef;
    border-radius: 4px;
  }
  
  .text-danger {
    color: #dc3545 !important;
  }
  </style>
  